<template>
  <div class="activPush">
    <div class="pic">
      <p>活动发布轮播图展示</p>
      <el-upload
        class="avatar-uploader"
        action="string"
        v-model="postPic"
        list-type="picture-card"
        :http-request="uploadSectionFile"
        :file-list="fileList"
        :on-remove="handleRemove"
        :before-upload="uploadSuccess"
        ref="imagePic"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <el-button
        type="primary"
        @click="submitPic"
        plain
        style="margin-left: 20px"
        >提交</el-button
      >
    </div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      plain
      @click="addActive()"
      >活动添加</el-button
    >
    <el-table
      border
      :data="tableData"
      style="width: 100%"
      :row-style="tableRowStyle"
      :header-cell-style="tableHeaderColor"
    >
      <el-table-column
        prop="activityName"
        label="活动名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="time"
        label="活动时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="activityType"
        label="活动状态"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            plain
            @click.native="editActive(scope.row)"
            >修改活动</el-button
          >
          <el-button
            size="small"
            type="warning"
            plain
            @click="overActive(scope.row)"
            >结束活动</el-button
          >
          <el-button
            size="small"
            type="danger"
            plain
            @click.native="DeletActive(scope.row)"
            >删除活动</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center; margin-top: 10px"
      background
      layout="total,prev, pager, next"
      :total="total"
      class="fenye"
      @current-change="changepage"
    ></el-pagination>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "ActivPush",
  data() {
    return {
      postPic: "",
      tableData: [],
      fileList: [], //图片回显
      picList: [], //图片id
      picBackList: [],
      total: 0, //总数
      pageNum: 1,
      pageSize: 7,
      fileDataList: [],
    };
  },
  methods: {
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      // return this.rowStyle;
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //添加活动
    addActive() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/ActivePush",
        params:{
          add: "true"
        }
      });
    },
    // 翻页
    changepage(val) {
      this.pageNum = val;
      this.getActiveList();
    },
    //获取活动列表
    getActiveList() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$postJson("omc/queryMachine/queryActivitiesWithPage", param).then(
        (res) => {
          this.total = Number(res.result.total);
          this.tableData = res.result.list.map((item) => {
            if (item.activityType == 1) {
              item.activityType = "已结束";
            } else {
              item.activityType = "进行中";
            }
            item.time = item.startTime + "至" + item.endTime;
            return item;
          });
        }
      );
    },
    //上传图片
    uploadSectionFile(param) {
      var fileObj = param.file;
      console.log(param.file);
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        console.log(form);
        this.$postFormData("opc/file/uploadFile", form).then((res) => {
          if (res.code == 200) {
            this.picList.push(res.result);
            this.$message({ message: res.message, type: "success" });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      }
    },

    //提交图片
    submitPic() {
      if (this.picList.length > 0) {
        let picString = this.picList.join(",");
        this.$postJson(
          "omc/queryMachine/addActivityCarousel/" + picString
        ).then((res) => {
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        this.$message({ message: "活动轮播图不能为空", type: "error" });
      }
    },

    //图片限制
    uploadSuccess(file) {
      this.fileDataList.push(file);
      const is10 = this.picList.length >= 10;
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PGN 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      if (is10) {
        this.$message.error("最多只能上传10张图片");
      }
      return isJPG && isLt2M && !is10;
    },

    //图片回显
    picBack() {
      this.$postJson("omc/queryMachine/queryCarouselList").then((res) => {
        this.picBackList = res.result.picId.split(",");
        this.picList = res.result.picId.split(",");
        for (var i = 0; i < this.picBackList.length; i++) {
          this.$postForm(
            "opc/file/queryAttachmentById/" + this.picBackList[i]
          ).then((res) => {
            this.fileList.push({
              name: res.result.name,
              id: res.result.id,
              url: "http://51cs8.com/" + res.result.path + res.result.name,
            });
          });
        }
      });
    },

    //图片删除
    handleRemove(file, fileList) {
      this.picList = this.picList.filter((item) => {
        return item != file.id;
      });
      for (let i = 0; i < this.fileDataList.length; i++) {
        if (file.uid == this.fileDataList[i].uid) {
          this.picList.splice(i + this.fileList.length, 1);
        }
      }
      // for (let k = 0; k < this.fileList.length; k++) {
      //   if (file.url == this.fileList[k].url) {
      //     this.picList.splice(k, 1);
      //   }
      // }
    },

    //编辑活动
    editActive(row) {
      if (row.activityType == "进行中") {
        bus.$emit("homePage", {
            type: "jump",
            path: "/ActivePush",
            params:{
              id: row.id,
            }
          });
      } else {
        this.$alert("该活动已结束,不能修改", "提示", {
          confirmButtonText: "确定",
          center: true,
          callback: (action) => {},
        });
      }
    },
    //删除活动
    DeletActive(row) {
      this.$confirm("确认删除该活动?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center:true
      })
        .then(() => {
          this.$postJson("omc/queryMachine/deleteByActivityId/" + row.id).then(
            (res) => {
              if (res.code == 200) {
                this.getActiveList();
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "success" });
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //结束活动
    overActive(row) {
      if (row.activityType == "进行中") {
        this.$confirm("确认结束该活动?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center:true
        })
          .then(() => {
            let param = {
              id: row.id,
              activityType: 1,
              activityName: row.activityName,
              activity: row.activity,
              remark: row.remark,
              startTime: row.startTime,
              endTime: row.endTime,
              firstPic: row.firstPic,
            };
            this.$postJson("omc/queryMachine/editActivity", param).then(
              (res) => {
                if (res.code == 200) {
                  this.getActiveList();
                  this.$message({ message: res.message, type: "success" });
                } else {
                  this.$message({ message: res.message, type: "error" });
                }
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消结束",
            });
          });
      } else {
        this.$alert("该活动已结束", "提示", {
          confirmButtonText: "确定",
          center: true,
          callback: (action) => {},
        });
      }
    },
  },
  mounted() {
    this.getActiveList();
    this.picBack();
  },
};
</script>
<style lang="scss">
.pic {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  p {
    margin-right: 20px;
  }
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>